document.querySelectorAll('[data-fibrax-comparator]').forEach((root) => {
  if (root.dataset.fxReady) return;
  root.dataset.fxReady = 'true';
  const $ = (selector) => root.querySelector(selector);
  const money = window.FibraxCore.formatMoney;
  const systems = {
    mesh1010: { steelTitle: 'Malla 6×6 10/10', steelType: 'mesh', rollPrice: Number(root.dataset.mesh1010Price || 2152), rollCoverage: 100, overlap: 0.10, chairsPer20: 4, chairPrice: Number(root.dataset.chairPrice || 4.26), laborPerM2: Number(root.dataset.meshLabor || 5), minThickness: 0, defaultThickness: 10, fiberTitle: 'Synmix EZ54', fiberType: 'Macrofibra sintética', dose: 1.81, fiberPrice: Number(root.dataset.synmixPrice || 145), packageKg: 10.86, packageLabel: 'caja', packageContents: '6 bolsas de 1.81 kg', engineering: false, variant: root.dataset.synmixVariant },
    mesh66: { steelTitle: 'Malla 6×6 6/6', steelType: 'mesh', rollPrice: Number(root.dataset.mesh66Price || 4492), rollCoverage: 100, overlap: 0.10, chairsPer20: 4, chairPrice: Number(root.dataset.chairPrice || 4.26), laborPerM2: Number(root.dataset.meshLabor || 5), minThickness: 0, defaultThickness: 12, fiberTitle: 'Synmix EZ54', fiberType: 'Macrofibra sintética estructural', dose: 3, fiberPrice: Number(root.dataset.synmixPrice || 145), packageKg: 10.86, packageLabel: 'caja', packageContents: '6 bolsas de 1.81 kg', engineering: false, variant: root.dataset.synmixVariant },
    rebar3: { steelTitle: 'Varilla #3 @ 30 cm', steelType: 'rebar', rebarWeight: 3.71, rebarPrice: Number(root.dataset.rebarPrice || 20.068), rebarLabor: Number(root.dataset.rebarLabor || 8), minThickness: 15, defaultThickness: 15, fiberTitle: 'Synmix EZ54', fiberType: 'Macrofibra sintética estructural', dose: 3, fiberPrice: Number(root.dataset.synmixPrice || 145), packageKg: 10.86, packageLabel: 'caja', packageContents: '6 bolsas de 1.81 kg', engineering: true, variant: root.dataset.synmixVariant },
    rebar4: { steelTitle: 'Varilla #4 @ 20 cm', steelType: 'rebar', rebarWeight: 9.96, rebarPrice: Number(root.dataset.rebarPrice || 20.068), rebarLabor: Number(root.dataset.rebarLabor || 8), minThickness: 15, defaultThickness: 15, fiberTitle: 'Dramix 4D 80/60BGE', fiberType: 'Fibra metálica', dose: 15, fiberPrice: Number(root.dataset.dramixPrice || 85), packageKg: 20, packageLabel: 'saco', packageContents: '1 saco de 20 kg', engineering: true, variant: root.dataset.dramixVariant }
  };

  let current = null;
  const plural = (n, singular, pluralWord) => n === 1 ? singular : pluralWord;
  const packageFiber = (system, targetKg) => {
    const count = Math.max(1, Math.ceil(targetKg / system.packageKg));
    const pluralLabel = system.packageLabel === 'caja' ? 'cajas' : 'sacos';
    return {
      count,
      suppliedKg: count * system.packageKg,
      summary: system.packageLabel === 'caja'
        ? `${count} ${plural(count, 'caja', 'cajas')} ${count === 1 ? 'cerrada' : 'cerradas'}`
        : `${count} ${plural(count, 'saco', 'sacos')} ${count === 1 ? 'completo' : 'completos'}`
    };
  };
  const assumption = (label, value) => `<div class="fx-assumption"><span>${label}</span><strong>${value}</strong></div>`;

  const calculate = (resetThickness = false) => {
    const key = $('[data-fx-reinforcement]').value;
    const system = systems[key];
    if (resetThickness) $('[data-fx-thickness]').value = system.defaultThickness;
    const area = Math.max(1, Number($('[data-fx-area]').value || 1));
    let thickness = Math.max(1, Number($('[data-fx-thickness]').value || 1));
    const waste = Number($('[data-fx-waste]').value || 0);
    const minimum = $('[data-fx-minimum-note]');
    if (system.minThickness && thickness < system.minThickness) {
      thickness = system.minThickness;
      $('[data-fx-thickness]').value = system.minThickness;
      minimum.textContent = `Para esta comparación, el espesor mínimo es de ${system.minThickness} cm.`;
      minimum.hidden = false;
    } else minimum.hidden = true;

    let steelTotal = 0, steelRequired = '', steelPurchase = '', steelLabor = '', steelDescription = '', assumptions = '';
    const rebarField = $('[data-fx-rebar-price-field]');
    const meshField = $('[data-fx-mesh-price-field]');
    rebarField.hidden = system.steelType !== 'rebar';
    meshField.hidden = system.steelType !== 'mesh';

    if (system.steelType === 'mesh') {
      if (!$('[data-fx-mesh-price]').dataset.edited) $('[data-fx-mesh-price]').value = system.rollPrice;
      const requiredArea = area * (1 + system.overlap);
      const rolls = Math.ceil(requiredArea / system.rollCoverage);
      const userMeshPrice = Math.max(0, Number($('[data-fx-mesh-price]').value || system.rollPrice));
      const meshCost = rolls * userMeshPrice;
      const chairs = Math.ceil(area * system.chairsPer20 / 20);
      const chairsCost = chairs * system.chairPrice;
      const laborCost = area * system.laborPerM2;
      steelTotal = meshCost + chairsCost + laborCost;
      steelRequired = `${requiredArea.toFixed(1)} m² con traslapes`;
      steelPurchase = `${rolls} ${rolls === 1 ? 'rollo' : 'rollos'} completos`;
      steelLabor = `${money(laborCost)} + ${chairs} silletas`;
      steelDescription = 'Malla, traslapes, silletas y colocación.';
      assumptions += assumption('Precio por rollo', money(userMeshPrice));
      assumptions += assumption('Cobertura por rollo', `${system.rollCoverage} m²`);
      assumptions += assumption('Traslape', `${system.overlap * 100}%`);
      assumptions += assumption('Colocación', `${money(system.laborPerM2)} por m²`);
    } else {
      if (!$('[data-fx-rebar-price]').dataset.edited) $('[data-fx-rebar-price]').value = system.rebarPrice;
      const designKg = area * system.rebarWeight;
      const purchaseKg = Math.ceil(designKg * (1 + waste));
      const userRebarPrice = Math.max(0, Number($('[data-fx-rebar-price]').value || system.rebarPrice));
      const materialCost = purchaseKg * userRebarPrice;
      const laborCost = purchaseKg * system.rebarLabor;
      steelTotal = materialCost + laborCost;
      steelRequired = `${designKg.toLocaleString('es-MX', { maximumFractionDigits: 0 })} kg`;
      steelPurchase = `${purchaseKg.toLocaleString('es-MX')} kg de varilla`;
      steelLabor = money(laborCost);
      steelDescription = 'Varilla, desperdicio y habilitado.';
      assumptions += assumption('Peso del armado', `${system.rebarWeight.toFixed(2)} kg/m²`);
      assumptions += assumption('Precio de varilla', `${money(userRebarPrice)} por kg`);
      assumptions += assumption('Habilitado', `${money(system.rebarLabor)} por kg`);
    }

    const volume = area * thickness / 100;
    const designFiberKg = volume * system.dose;
    const targetFiberKg = designFiberKg * (1 + waste);
    const purchase = packageFiber(system, targetFiberKg);
    const fiberTotal = purchase.suppliedKg * system.fiberPrice;
    const steelPerM2 = steelTotal / area;
    const fiberPerM2 = fiberTotal / area;
    const difference = steelTotal - fiberTotal;
    const percent = steelTotal ? difference / steelTotal * 100 : 0;
    const positive = difference >= 0;
    current = { system, purchase, targetFiberKg, area, thickness };

    $('[data-fx-result-subtitle]').textContent = `${area.toLocaleString('es-MX')} m² con ${thickness} cm de espesor.`;
    $('[data-fx-steel-title]').textContent = system.steelTitle;
    $('[data-fx-steel-description]').textContent = steelDescription;
    $('[data-fx-steel-total]').textContent = money(steelTotal);
    $('[data-fx-steel-per-m2]').textContent = `${money(steelPerM2)} por m²`;
    $('[data-fx-steel-required]').textContent = steelRequired;
    $('[data-fx-steel-purchase]').textContent = steelPurchase;
    $('[data-fx-steel-labor]').textContent = steelLabor;
    $('[data-fx-fiber-title]').textContent = system.fiberTitle;
    $('[data-fx-fiber-description]').textContent = `${system.fiberType} a ${system.dose.toFixed(2)} kg/m³.`;
    $('[data-fx-fiber-total]').textContent = money(fiberTotal);
    $('[data-fx-fiber-per-m2]').textContent = `${money(fiberPerM2)} por m²`;
    $('[data-fx-fiber-required]').textContent = `${targetFiberKg.toFixed(2)} kg`;
    $('[data-fx-fiber-purchase]').textContent = purchase.summary;
    $('[data-fx-fiber-supplied]').textContent = `${purchase.suppliedKg.toFixed(2)} kg`;
    $('[data-fx-saving-label]').textContent = positive ? 'Ahorro estimado con fibra' : 'Costo adicional de la fibra';
    $('[data-fx-saving-amount]').textContent = money(Math.abs(difference));
    $('[data-fx-saving-percent]').textContent = `${Math.abs(percent).toFixed(1)}%`;
    const saving = $('[data-fx-saving-box]');
    const color = positive ? 'var(--fx-green)' : 'var(--fx-red)';
    saving.style.background = positive ? 'var(--fx-green-bg)' : 'var(--fx-red-bg)';
    saving.style.borderColor = positive ? '#abefc6' : '#fecdca';
    $('[data-fx-saving-label]').style.color = color;
    $('[data-fx-saving-amount]').style.color = color;
    $('[data-fx-saving-percent]').style.color = color;
    assumptions += assumption('Dosificación de fibra', `${system.dose.toFixed(2)} kg/m³`);
    assumptions += assumption('Precio de fibra', `${money(system.fiberPrice)} por kg`);
    assumptions += assumption('Presentación cerrada', `${system.packageLabel === 'caja' ? 'Caja' : 'Saco'} de ${system.packageKg.toFixed(2)} kg · ${system.packageContents}`);
    assumptions += assumption('Desperdicio aplicado', `${(waste * 100).toFixed(0)}%`);
    $('[data-fx-assumptions]').innerHTML = assumptions;
    $('[data-fx-engineering]').hidden = !system.engineering;
  };

  $('[data-fx-reinforcement]').addEventListener('change', () => {
    $('[data-fx-rebar-price]').dataset.edited = '';
    $('[data-fx-mesh-price]').dataset.edited = '';
    calculate(true);
  });
  $('[data-fx-rebar-price]').addEventListener('input', (event) => { event.currentTarget.dataset.edited = 'true'; calculate(false); });
  $('[data-fx-mesh-price]').addEventListener('input', (event) => { event.currentTarget.dataset.edited = 'true'; calculate(false); });
  ['[data-fx-area]', '[data-fx-thickness]', '[data-fx-waste]'].forEach((selector) => $(selector).addEventListener('change', () => calculate(false)));
  $('[data-fx-calculate]').addEventListener('click', () => calculate(false));
  $('[data-fx-add-comparison]').addEventListener('click', (event) => {
    window.FibraxCore.addToCart({
      variantId: current.system.variant,
      quantity: current.purchase.count,
      unitLabel: current.system.packageLabel,
      root,
      button: event.currentTarget,
      properties: {
        Comparación: current.system.steelTitle,
        Fibra: current.system.fiberTitle,
        Dosificación: `${current.system.dose.toFixed(2)} kg/m³`,
        Superficie: `${current.area} m²`,
        Espesor: `${current.thickness} cm`,
        Presentación: `${current.system.packageLabel === 'caja' ? 'Caja cerrada' : 'Saco completo'} de ${current.system.packageKg.toFixed(2)} kg`,
        Contenido: current.system.packageContents
      }
    });
  });
  $('[data-fx-advisor]').addEventListener('click', () => {
    window.location.href = window.FibraxCore.withQuery(root.dataset.advisorUrl, {
      comparacion: current.system.steelTitle,
      fibra: current.system.fiberTitle,
      superficie: `${current.area} m²`,
      espesor: `${current.thickness} cm`,
      compra: current.purchase.summary
    });
  });
  calculate(true);
});
